var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowserGradient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14C-2.73959e-08 15.8385 0.362121 17.659 1.06569 19.3576C1.76925 21.0561 2.80048 22.5995 4.1005 23.8995C5.40053 25.1995 6.94387 26.2307 8.64243 26.9343C10.341 27.6379 12.1615 28 14 28C15.8385 28 17.659 27.6379 19.3576 26.9343C21.0561 26.2307 22.5995 25.1995 23.8995 23.8995C25.1995 22.5995 26.2307 21.0561 26.9343 19.3576C27.6379 17.659 28 15.8385 28 14C28 10.287 26.525 6.72601 23.8995 4.10051C21.274 1.475 17.713 0 14 0C10.287 0 6.72601 1.475 4.1005 4.10051C1.475 6.72601 5.53285e-08 10.287 0 14ZM26.3529 14C26.3529 17.2762 25.0515 20.4182 22.7348 22.7348C20.4182 25.0515 17.2762 26.3529 14 26.3529C10.7238 26.3529 7.58178 25.0515 5.26515 22.7348C2.94853 20.4182 1.64706 17.2762 1.64706 14C1.64706 10.7238 2.94853 7.58178 5.26515 5.26515C7.58178 2.94853 10.7238 1.64706 14 1.64706C17.2762 1.64706 20.4182 2.94853 22.7348 5.26515C25.0515 7.58178 26.3529 10.7238 26.3529 14Z",
    fill: "url(#paint0_linear_4314_145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23529 14C8.23529 21.2405 10.6104 27.1765 14 27.1765C17.3896 27.1765 19.7647 21.2405 19.7647 14C19.7647 6.75953 17.3896 0.823529 14 0.823529C10.6104 0.823529 8.23529 6.75953 8.23529 14ZM18.1176 14C18.1176 20.4054 16.0671 25.5294 14 25.5294C11.9329 25.5294 9.88235 20.4054 9.88235 14C9.88235 7.59459 11.9329 2.47059 14 2.47059C16.0671 2.47059 18.1176 7.59459 18.1176 14Z",
    fill: "url(#paint1_linear_4314_145)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68118 6.2791L4.78471 5.05699C4.96039 5.2151 5.14871 5.36938 5.34965 5.51981C7.52047 7.1471 10.9464 8.13863 14.6802 8.13863C17.864 8.13863 20.8353 7.41887 23.0061 6.17863C23.5062 5.89556 23.9788 5.56636 24.4176 5.19534L25.4882 6.4471C24.9963 6.86765 24.4418 7.25416 23.8247 7.60663C21.392 8.9984 18.1391 9.78569 14.6802 9.78569C10.612 9.78569 6.83694 8.69369 4.36141 6.83746C4.12645 6.66099 3.89948 6.47579 3.68118 6.2791ZM3.68118 21.7417L4.78471 22.9605C4.96039 22.8013 5.14871 22.6476 5.34965 22.4993C7.52047 20.872 10.9464 19.8805 14.6802 19.8805C17.864 19.8805 20.8353 20.5986 23.0061 21.8405C23.5354 22.1447 24.0059 22.4719 24.4176 22.8222L25.4882 21.5704C24.9711 21.1329 24.4141 20.7447 23.8247 20.4109C21.392 19.0208 18.1391 18.2335 14.6802 18.2335C10.612 18.2335 6.83694 19.3255 4.36141 21.18C4.11984 21.3612 3.8931 21.5495 3.68118 21.7417ZM0.823529 14.824V13.177H27.1765V14.824H0.823529Z",
    fill: "url(#paint2_linear_4314_145)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4314_145",
    x1: -4.70556,
    y1: 58.1,
    x2: -31.076,
    y2: 35.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4314_145",
    x1: -4.70556,
    y1: 58.1,
    x2: -31.076,
    y2: 35.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4314_145",
    x1: -4.70556,
    y1: 58.1,
    x2: -31.076,
    y2: 35.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserGradient);
export default __webpack_public_path__ + "static/media/browser_gradient.73940d57b24051eff06d9aac49e39fee.svg";
export { ForwardRef as ReactComponent };